<div class="ar-insurance-payment-overpay-confirm" data-cy="ar-insurance-payment-processor-confirm">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-insurance-payment-processor-confirm-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-insurance-payment-processor-confirm-header">
      <div class="section-header-title" data-cy="ar-insurance-payment-processor-confirm-title">
        Confirm Charge(s)
      </div>
    </div>

    <!--  MAIN AREA-->
    @if (ispaymentLoading) {
      <app-tdo-progress-spinner class="spinner" diameter="70" data-cy="ar-insurance-payment-processor-confirm-payment-spinner"></app-tdo-progress-spinner>
    }

    <div class="section-content" style="display: flex; flex-direction: column; flex: 1; overflow: hidden; height: 100%;" data-cy="ar-insurance-payment-processor-confirm-content">
      @if (isLoading) {
        <app-tdo-progress-spinner style="flex: 1;" data-cy="ar-insurance-payment-processor-confirm-loading-spinner"></app-tdo-progress-spinner>
      }
      @if (!isLoading) {
        <div style="overflow: auto; height: 270px" data-cy="ar-insurance-payment-processor-confirm-loaded-content">
          <div data-cy="ar-insurance-payment-processor-confirm-message">These are the doctor accounts and totals that will be received once the charge is made:</div>
          <br /><br />
          <div style="display: flex; flex-direction: column" data-cy="ar-insurance-payment-processor-confirm-accounts">
            <div style="flex:1" data-cy="ar-insurance-payment-processor-confirm-header-row">
              <div style="display: flex; flex-direction: row" data-cy="ar-insurance-payment-processor-confirm-headers">
                <div style="flex:2;" class="trans_header_item_cell" data-cy="ar-insurance-payment-processor-confirm-header-account">Account</div>
                <div style="flex:2;" class="trans_header_item_cell" data-cy="ar-insurance-payment-processor-confirm-header-processor">Payment Processor</div>
                <div style="flex:1;" class="trans_header_item_cell" data-cy="ar-insurance-payment-processor-confirm-header-total">Total</div>
                <div style="flex:1;" class="trans_header_item_cell" data-cy="ar-insurance-payment-processor-confirm-header-actions">&nbsp;</div>
              </div>
            </div>
            @for (valPayDoc of dataDoctorARPaymentProcessors; track valPayDoc; let i = $index) {
              <div style="flex:1" [class.offset-item]="i % 2" data-cy="ar-insurance-payment-processor-confirm-row">
                <div style="display: flex; flex-direction: row" data-cy="ar-insurance-payment-processor-confirm-row-content">
                  <div style="flex:2" class="trans_header_cell" data-cy="ar-insurance-payment-processor-confirm-account">{{ valPayDoc.ARAccountName }}</div>
                  <div style="flex:2" class="trans_header_cell" data-cy="ar-insurance-payment-processor-confirm-processor">{{ valPayDoc.PaymentProcessorName }}</div>
                  <div style="flex:1" class="trans_header_cell" data-cy="ar-insurance-payment-processor-confirm-total">{{ valPayDoc.PaymentAmountTotal | currency }}</div>
                  <div style="flex:1" class="trans_header_cell" style="flex: 1;" data-cy="ar-insurance-payment-processor-confirm-actions">
                    <div style="display: flex" data-cy="ar-insurance-payment-processor-confirm-buttons-container">
                      <div style="flex: 1;" data-cy="ar-insurance-payment-processor-confirm-button-wrapper">
                        <div style="display: flex" data-cy="ar-insurance-payment-processor-confirm-button-row">
                          <div style="flex-basis: 110px;" data-cy="ar-insurance-payment-processor-confirm-button-container">
                            @if (!valPayDoc.ChargeSuccess) {
                              <button style="width: 110px;" (click)="chargeCard(valPayDoc)" [disabled]="ispaymentLoading || valPayDoc.ChargeSuccess" class="tdo-button tdo-save" style="font-size:10px" data-cy="ar-insurance-payment-processor-confirm-charge-btn">CHARGE</button>
                            }
                            @if (valPayDoc.ChargeSuccess) {
                              <button [disabled]="isPrintingReceipt" style="width: 110px;" (click)="openPaymentReceipt(valPayDoc)" class="tdo-button tdo-save" style="font-size:10px" data-cy="ar-insurance-payment-processor-confirm-receipt-btn">Receipt</button>
                            }
                          </div>
                          @if (valPayDoc.ChargeSuccess) {
                            <div style="flex: 1; text-align: left; padding-top:3px" data-cy="ar-insurance-payment-processor-confirm-success-icon">
                              <span class="material-symbols-outlined" style="color: green" data-cy="ar-insurance-payment-processor-confirm-check-icon">
                                check_circle
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!--  FOOTER-->
      @if (!isLoading) {
        <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="ar-insurance-payment-processor-confirm-footer">
          <div style="flex: 1; margin-right: 6px;" data-cy="ar-insurance-payment-processor-confirm-footer-spacer"></div>
          <button (click)="cancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-insurance-payment-processor-confirm-close-btn">Close</button>
        </div>
      }
    </div>
  </div>



